export function formatPhoneNumber(phoneNumberString = ''): string {
  const match = phoneNumberString?.match(/^(\d{3})(\d{3})(\d{4})$/)

  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumberString
}

/**
 * Remove the US country code from a phone number string if it exists
 * If no country code exists, return the original phone number string
 */
export function removeUsCountryCode(phoneNumberString = ''): string {
  return phoneNumberString?.replace(/^(\+?1)/, '') ?? phoneNumberString
}

export function removeNonDigits(phoneNumberString = ''): string {
  return phoneNumberString?.replace(/\D/g, '') ?? phoneNumberString
}
